import React from "react";
import Nav from "../../nav";
import Container from "../../container";

import "../../../styles/writing.scss";
import { Link } from "gatsby";
import Footer from "../../footer";

export default function WritingTemplate({
  title,
  subtitle,
  children,
  imageLink,
}) {
  return (
    <main>
      <div className="writing__template">
        <div
          className="writing__template__header"
        >
          <div className="cover" style={{ backgroundImage: `url(${imageLink})` }}></div>
          <Nav />
          <Container>
            <div className="writing__template__header__content">
              <h1>{title}</h1>
              <p>{subtitle}</p>
            </div>
          </Container>
        </div>
        <div className="writing__template__content">
          {children}
          <Link to="/writing" className="writing__back__link">
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M6.52203 9.1664H16.6654V10.8331H6.52203L10.992 15.3031L9.8137 16.4814L3.33203 9.99973L9.8137 3.51807L10.992 4.6964L6.52203 9.1664Z"
                fill="black"
              />
            </svg>
            Back to writings
          </Link>
        </div>
      </div>
      <Footer />
    </main>
  );
}
